module.exports = __webpack_public_path__ + "img/wanwu_11.4bc2da72.png";